import React, { createContext, useContext, useMemo, useState } from 'react';

export type MenuContextType = {
  focusedItemKey: string | number | null;
  setFocusedItemKey: (key: string | number | null) => void;
  isKeyboardNavigation: boolean;
  setIsKeyboardNavigation: (value: boolean) => void;
};

const MenuContext = createContext<MenuContextType | null>(null);

export const useMenuContext = () => {
  const context = useContext(MenuContext);
  if (!context) {
    return null;
  }
  return context;
};

type MenuContextProviderProps = {
  children: React.ReactNode;
};

export const MenuContextProvider: React.FC<MenuContextProviderProps> = ({
  children,
}) => {
  const [focusedItemKey, setFocusedItemKey] = useState<string | number | null>(
    null,
  );
  const [isKeyboardNavigation, setIsKeyboardNavigation] = useState(false);

  const obj = useMemo(
    () => ({
      focusedItemKey,
      setFocusedItemKey,
      isKeyboardNavigation,
      setIsKeyboardNavigation,
    }),
    [focusedItemKey, isKeyboardNavigation],
  );

  return <MenuContext.Provider value={obj}>{children}</MenuContext.Provider>;
};
